import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "contents1"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  id: "contents1"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = { class: "com_inner1 clearfix" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "com_fs15" }, [
  /*#__PURE__*/_createTextVNode(" 売上日報には"),
  /*#__PURE__*/_createElementVNode("span", { class: "com_color1" }, "個人情報"),
  /*#__PURE__*/_createTextVNode("が含まれます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" カウネット運用マニュアルに記載されている「顧客情報取扱いの諸注意」に遵守いただきますようお願い申し上げます。 ")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "error-message com_mgb10",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_9 = { class: "com_block1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "エージェントコード"),
  /*#__PURE__*/_createElementVNode("p", { class: "com_fs12 com_color1" }, "※必須項目です")
], -1)
const _hoisted_11 = { class: "com_a_table1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"5%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"80%"} })
], -1)
const _hoisted_13 = { style: {"width":"5%"} }
const _hoisted_14 = { class: "com_checkbox3" }
const _hoisted_15 = ["checked"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", null, "コード", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", null, "エージェント名", -1)
const _hoisted_18 = { class: "com_checkbox3" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "com_mgb10" }, " ※検索条件のアップロードにはCSVファイルを使用してください。(1行1明細) ", -1)
const _hoisted_21 = { class: "com_block1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "発行日または売上日(選択)"),
  /*#__PURE__*/_createElementVNode("p", { class: "com_fs12 com_color1" }, "※必須項目です")
], -1)
const _hoisted_23 = { class: "com_b_cnt1" }
const _hoisted_24 = { class: "com_f_group1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, null, -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = ["value"]
const _hoisted_28 = ["max"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "t1" }, "～", -1)
const _hoisted_30 = ["max"]
const _hoisted_31 = { class: "com_fs14 t2" }
const _hoisted_32 = { class: "com_fs15 com_lh14 com_mgt10 com_mgb0" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = { class: "com_u_cnt1" }
const _hoisted_35 = { class: "com_inner1 clearfix" }
const _hoisted_36 = {
  key: 0,
  class: "com_inner1 clearfix com_mgt15"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "com_fs15" }, " 売上日報ファイルを作成しました。ダウンロードリンクをクリックし、ファイルを保存してください。 ")
], -1)
const _hoisted_38 = { class: "div-kan com_mgb10" }
const _hoisted_39 = { style: {"display":"flex"} }
const _hoisted_40 = { style: {"margin-left":"12px","vertical-align":"middle"} }
const _hoisted_41 = { style: {"margin-left":"60px"} }
const _hoisted_42 = { style: {"width":"900px"} }
const _hoisted_43 = { class: "com_a_table1" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} }, "エージェントコード"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"35%"} }, "エージェント名"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"45%"} }, "ダウンロードリンク")
  ])
], -1)
const _hoisted_45 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_BreadcrumbsComponent = _resolveComponent("BreadcrumbsComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!
  const _component_LoadingOverlayComponent = _resolveComponent("LoadingOverlayComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDataFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_BreadcrumbsComponent, {
                title: '',
                categoryId: _ctx.categoryId
              }, null, 8, ["categoryId"]),
              _hoisted_7,
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", null, [
                  _createElementVNode("table", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: _ctx.isAllChecked,
                              class: "check_all1",
                              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAllAgents && _ctx.toggleAllAgents(...args)))
                            }, null, 40, _hoisted_15)
                          ])
                        ]),
                        _hoisted_16,
                        _hoisted_17
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agList, (agent, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("label", _hoisted_18, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((agent.selection) = $event),
                                class: "check_all1"
                              }, null, 8, _hoisted_19), [
                                [_vModelCheckbox, agent.selection]
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(agent.agCode), 1),
                          _createElementVNode("td", null, _toDisplayString(agent.agName), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputData.dateKbn) = $event)),
                        class: "com_f_control1"
                      }, [
                        _hoisted_25,
                        _createElementVNode("option", {
                          value: _ctx.UriRptDownloadConstants.DATE_KBN_ISSUE
                        }, " 発行日 ", 8, _hoisted_26),
                        _createElementVNode("option", {
                          value: _ctx.UriRptDownloadConstants.DATE_KBN_SALES
                        }, " 売上日 ", 8, _hoisted_27)
                      ], 512), [
                        [_vModelSelect, _ctx.inputData.dateKbn]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputData.dateFrom) = $event)),
                        max: _ctx.AppConstants.MAX_DATE_VALUE,
                        class: "com_f_control1 com_center1",
                        style: {"width":"auto"}
                      }, null, 8, _hoisted_28), [
                        [_vModelText, _ctx.inputData.dateFrom]
                      ]),
                      _hoisted_29,
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputData.dateTo) = $event)),
                        max: _ctx.AppConstants.MAX_DATE_VALUE,
                        class: "com_f_control1 com_center1",
                        style: {"width":"auto"}
                      }, null, 8, _hoisted_30), [
                        [_vModelText, _ctx.inputData.dateTo]
                      ]),
                      _createElementVNode("span", _hoisted_31, " （年は西暦/最大期間" + _toDisplayString(_ctx.getValueById(
                      _ctx.checkSettings,
                      _ctx.UriRptDownloadConstants.KEY_CHECK_SETTINGS_DATE_RANGE_DAYS
                    )) + "日） ", 1)
                    ]),
                    _createElementVNode("p", _hoisted_32, [
                      _createTextVNode(" 発行日：売上日報がメールで届いた日付です。   売上日：売上日報データの売上日です。"),
                      _hoisted_33,
                      _createTextVNode(" " + _toDisplayString(_ctx.formatMessage(
                    _ctx.getValueById(
                      _ctx.displayMessages,
                      _ctx.UriRptDownloadConstants.KEY_DISPLAY_TEXT_PAST_TARGET_SPAN
                    ),
                    [
                      _ctx.getValueById(
                        _ctx.checkSettings,
                        _ctx.UriRptDownloadConstants.KEY_CHECK_SETTINGS_START_DATE_LOOKBACK_MONTHS
                      ),
                    ]
                  )), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'ReportDownload' },
                      class: "com_link2 b",
                      style: {"margin-left":"12px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("各種ダウンロードへ戻る")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnSerch",
                      class: "com_search_button1",
                      style: {"width":"180px"},
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSerch && _ctx.onSerch(...args)))
                    }, " 売上日報検索 "),
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnClear",
                      class: "com_clear_button1",
                      style: {"width":"120px","margin-right":"12px"},
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                    }, " クリア ")
                  ])
                ])
              ])
            ]),
            (_ctx.outputDataList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          type: "button",
                          name: "btnDownload",
                          class: "uri_res_button1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (
                  _ctx.onDownload(_ctx.UriRptDownloadConstants.DOWNLOAD_TYPE_TEMPLATE, '')
                ))
                        }, " Excelひな形ファイル ")
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.getValueById(
                    _ctx.displayMessages,
                    _ctx.UriRptDownloadConstants.KEY_DISPLAY_TEXT_TEMPLATE_FILE
                  )), 1)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("button", {
                          type: "button",
                          name: "btnDownload",
                          class: "uri_res_button1",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (
                  _ctx.onDownload(
                    _ctx.UriRptDownloadConstants.DOWNLOAD_TYPE_ZIP,
                    _ctx.zipFileName
                  )
                ))
                        }, " 全ファイルダウンロード ")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("table", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outputDataList, (data, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(data.agCode), 1),
                            _createElementVNode("td", null, _toDisplayString(data.agName), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("a", {
                                href: "#",
                                class: "com_link1",
                                onClick: _withModifiers(($event: any) => (
                      _ctx.onDownload(
                        _ctx.UriRptDownloadConstants.DOWNLOAD_TYPE_TSV,
                        data.rptName
                      )
                    ), ["prevent"])
                              }, _toDisplayString(data.rptName), 9, _hoisted_45)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingOverlayComponent, {
          key: 2,
          lines: _ctx.loadLines
        }, null, 8, ["lines"]))
      : _createCommentVNode("", true)
  ], 64))
}